import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
    selector: 'app-url-button-cell',
    templateUrl: './url-button-cell.component.html',
    styleUrls: ['./url-button-cell.component.scss'],
    standalone: false,
})
export class UrlButtonCellComponent implements ICellRendererAngularComp {
    url!: string;

    constructor() {}

    agInit(params: ICellRendererParams): void {
        this.url = params.value;
    }

    refresh(params: ICellRendererParams): boolean {
        this.url = params.value;
        return true;
    }
}
